@tailwind base;
@tailwind components;
@tailwind utilities;

/*
 * Default web font. react-native-web's <Text> already sets this system stack on
 * its own generated class, so this only fills in plain DOM elements (raw
 * <div>/<p>/Tailwind components) that would otherwise fall back to the browser's
 * serif default. Element-level specificity — it never overrides RN inline/class
 * styles, so existing Expo rendering is untouched.
 */
:root {
  --app-font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

html,
body {
  font-family: var(--app-font-sans);
}

/* Form controls don't inherit font-family by default; opt them in (RN's own
   class styles still win for react-native-web inputs). */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
}

.link:hover {
  text-decoration: underline;
}
.table-row {
  background-color: rgba(0, 0, 0, 0);
}
.table-row:hover {
  backdrop-filter: brightness(60%);
}
.table-cell:hover {
  backdrop-filter: brightness(60%);
}


/* @media (color-scheme: dark) { */
/*   .table-row:hover { */
/*     background-color: red; */
/*   } */
/* } */
